import React from 'react';

import { useAppDispatch, useAppSelector } from 'app/hooks';
import { getGlobalFilter } from 'dashboard/topFilter/OhsTopFilterSlice';
import {
  fetchOnboardingListAsync,
  fetchOnboardingListCountAsync,
  getOhsOnboardingList,
  setCurrentRegisterPage,
} from 'freemium/list/OhsOnboardingListSlice';
import OhsUserLocalServices from 'user/OhsUserLocalServices';

export default function useOhsOnboardingList() {
  const [currentPage, setCurrentPage] = React.useState<number>(1);
  const filter = useAppSelector(getGlobalFilter);
  const dispatch = useAppDispatch();
  const onboardingReducer = useAppSelector(getOhsOnboardingList);

  const { onboardingList, isLoading } = onboardingReducer;
  const user = OhsUserLocalServices.getLocalOhsUser();

  const fetchOnboardingList = async () => {
    if (user) {
      await dispatch(fetchOnboardingListAsync());
      await dispatch(fetchOnboardingListCountAsync());
    }
  };

  React.useEffect(() => {
    dispatch(setCurrentRegisterPage(currentPage));
    fetchOnboardingList();
  }, [user?._id, currentPage, filter]);

  return { isLoading, onboardingList, currentPage, setCurrentPage, fetchOnboardingList } as const;
}
